'use strict';

exports.__esModule = true;
exports.page = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _pageActions = require('../actions/page-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_pageState', {
    value: require('react').PropTypes.shape({
        errorCode: require('react').PropTypes.string,
        errorMessage: require('react').PropTypes.string,
        loadedUri: require('react').PropTypes.bool.isRequired
    })
});


var INITIAL_STATE = {
    loadedUri: false
};

var page = exports.page = function page(state, action) {

    switch (action.type) {
        case _pageActions.LOAD_URI:
        case _pageActions.LOADED_URI:
            return (0, _extends3.default)({}, state, action.payload);
        default:
            return state || INITIAL_STATE;
    }
};


// WEBPACK FOOTER //
// ./components/error-page/lib/reducers/page-reducers.js